import { useState, useRef, useEffect } from "react";
import "../assets/styles/home-page.css";

// import asIcon from "../assets/images/as-icon.ico";
import asIcon from "../assets/images/statement.png";
import termsIcon from "../assets/images/terms.png";
import rbIcon from "../assets/images/rb-icon.png";
import depositIcon from "../assets/images/deposit.png";
import moneyIcon from "../assets/images/moneyIcon.png";

import NotActiveUser from "./NotActiveUser.jsx";
import ImageCard from "../components/ImageCard.jsx";
import SelectDate from "../components/SelectDate";
import RadioButton from "../components/RadioButton.jsx";
import Layout from "../components/Layout";
import DepositCard from "../components/DepositCard.jsx";
import ButtonComponent from "../components/ButtonComponent.jsx";
import StandardTree from "../components/StandardTree.jsx";
import ArchiveAccountStatement from "../components/ArchiveAccountStatement.jsx";
import DisableButton from "../components/DisableButton.jsx";
import {
  getAllDeposits,
  getArchiveAccountStatement,
} from "../services/depositService.js";
import Spinner from "react-bootstrap/Spinner";
import TermsSection from "../components/TermsSection.jsx";
import depositsDataFilter from "../constants/depositsDataFilter.js";
import AccountStatementSection from "../components/AccountStatementSection.jsx";
import ScrollToTop from "../components/ScorllToTop.jsx";
import { useAuth } from "../auth/AuthContext.js";
import { Button, Modal } from "react-bootstrap";
import { MegaphoneFill } from "react-bootstrap-icons";

function HomePage() {
  const { userInfo , announcementModal,setAnnouncementModal} = useAuth();
  const empActive = userInfo?.isEmpActive;
  const isEmpCreatedAccount = userInfo?.isEmpCreateAccount;

  const sectionRefs = useRef({});
  const [archiveSection, setArchiveSection] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [cardData, setCardData] = useState([]);
  const [monthFilterError, setMonthFilterError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().getFullYear());
  const [selectedType, setSelectedType] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [isMonthFilterActive, setIsMonthFilterActive] = useState(false);
  const [fromMonth, setFromMonth] = useState("");
  const [toMonth, setToMonth] = useState("");

  const allDepositsscrollToTop = useRef(null);

  const [sections, setSections] = useState({
    accountStatementSection: false,
    allDepositSection: false,
    newDepositSection: false,
    termsSection: false,
  });

  const fetchArchiveAccountStatement = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await getArchiveAccountStatement();
      setArchiveSection(true);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleSection = (sectionName) => {
    setSections((prevSections) => {
      const newSections = {
        ...Object.keys(prevSections).reduce((acc, key) => {
          acc[key] = key === sectionName ? !prevSections[key] : false;
          return acc;
        }, {}),
      };

      // Call closeSection if the section is being closed
      if (!newSections[sectionName] && prevSections[sectionName]) {
        closeSection();
      }

      if (newSections[sectionName]) {
        sectionRefs.current[sectionName].scrollIntoView({ behavior: "smooth" });
      }
      if (sectionName === "allDepositSection") {
        try {
          setIsLoading(true);
          setError(null);
          fetchAllDeposits();
        } catch (error) {
          alert("حدث خطأ اثناء جلب البيانات");
        }
      }
      return newSections;
    });
  };

  const handleFromMonthChange = (e) => {
    setFromMonth(e.target.value);
  };

  const handleToMonthChange = (e) => {
    setToMonth(e.target.value);
  };

  const handleUpdateClick = () => {
    try {
      if (parseInt(fromMonth) > parseInt(toMonth)) {
        setFromMonth("");
        setToMonth("");
        setMonthFilterError(
          "هنالك خطأ ، لايمكن وضع الشهر (من) اكبر من الشهر (الى)"
        );
        return;
      }
      setMonthFilterError(null);
      fetchAllDeposits();
    } catch (error) {
      console.error(` Error in filtering month :  ${error}`);
    }
  };

  const fetchAllDeposits = async (
    overrideFromMonth = fromMonth,
    overrideToMonth = toMonth,
    overrideIsMonthFilterActive = isMonthFilterActive,
    overrideYear = selectedDate
  ) => {
    try {
      setIsLoading(true);
      setError(null);

      let fromDate = null;
      let toDate = null;

      const year = overrideYear;

      if (overrideIsMonthFilterActive) {
        if (overrideFromMonth) {
          fromDate = `${year}-${String(overrideFromMonth).padStart(2, "0")}`;
        }
        if (overrideToMonth) {
          toDate = `${year}-${String(overrideToMonth).padStart(2, "0")}`;
        }
      }

      // Call API with correct parameters
      const data = await getAllDeposits(year, fromDate, toDate);
      setCardData(data);
      setFilteredData(data);
      filterData(data);
      setMonthFilterError(null);
    } catch (error) {
      setMonthFilterError(
        `لايوجد بيانات ضمن هذه الشهور المدخلة: ${fromMonth} - ${toMonth}`
      );
      setCardData([]);
      console.error(`Error in month filtering: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMonthFilter = () => {
    try {
      const newState = !isMonthFilterActive;
      setIsMonthFilterActive(newState);

      if (!newState) {
        setFromMonth("");
        setToMonth("");
        setMonthFilterError(null);

        setTimeout(() => {
          fetchAllDeposits(null, null, newState);
        }, 0);
      }
    } catch (error) {
      console.error(error);
      setMonthFilterError("حدث خطأ اثناء تصفية الشهر");
    }
  };

  const filterData = (data) => {
    const filtered = data.filter((item) => {
      const isYearMatch = selectedDate
        ? new Date(item.createdAt).getFullYear() === selectedDate
        : true;
      const isTypeMatch =
        selectedType === "all"
          ? true
          : item.state.toLowerCase() === selectedType;
      return isYearMatch && isTypeMatch;
    });

    setFilteredData(filtered);
  };

  const handleDateChange = async (date) => {
    setIsMonthFilterActive(false);
    setSelectedDate(date);
    await fetchAllDeposits(undefined, undefined, false, date);
  };

  const handleRadioChange = (e) => {
    setSelectedType(e.target.value);
    filterData(cardData);
  };

  useEffect(() => {
    filterData(cardData);
  }, [selectedType, selectedDate, cardData]);

  const closeSection = () => {
    setSections({
      accountStatementSection: false,
      allDepositSection: false,
      newDepositSection: false,
      termsSection: false,
    });
    setSelectedDate(new Date().getFullYear());
    setSelectedType("all");
    setFilteredData([]);
    setArchiveSection(false);
    setMonthFilterError(null);
    setIsMonthFilterActive(false);
  };

  // If user has created his own account , there will be check first then 
  // admin can active his account (if he is employee in OC colleges.)
  // if (isEmpCreatedAccount === true || empActive === "True" & (empActive === false || empActive === "False") ) return <CheckNewCreatedAccount />;
  if (empActive === false || empActive === "False") return <NotActiveUser />;

  return (
    <Layout>
      {/* Cards  */}

{announcementModal && (
   <Modal
  show={announcementModal}
  onHide={() => setAnnouncementModal(false)}
  centered
  size="xl"  // wider
  dialogClassName="announcement-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>
تنويه هام
      <MegaphoneFill className="text-danger mx-1" /> 
</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ lineHeight: "1.8", direction: "rtl", textAlign: "right" }}>
    <section className="mb-4">
      <p className="text-danger">
   تود كليات عنيزة أن تنوّه إلى أن عدم تحقيق الحد الأدنى من متطلبات الإنجاز الموضحة أدناه، قد يترتب عليه عدم تجديد عقد العضو/الموظف بنهاية العام الدراسي 1448هـ.
وقد تم تحديد المتطلبات وفقاً لطبيعة الوظيفة سواء كان
 <span className="fw-bold"> عضو هيئة تدريس  </span> أو <span className="fw-bold">  إداري/فني </span> 
 ،
 وذلك على النحو التالي:


    </p>
    </section>

    <hr />

    <section className="mb-4">
      <h5 className="mb-3 text-danger">أولاً: متطلبات الحد الأدنى لإنجاز عضو هيئة التدريس خلال العام الدراسي 1448هـ:</h5>
      <ul>
        <li>استكمال بند جودة التدريس  نظام البلاكبورد (معيار التعليم والتعلم)</li>
        <li>استكمال بند جودة التدريس  نظام الجودة الداخلي   (معيار التعليم والتعلم).</li>
        <li>استكمال بند تقييم الطالب للعضو (معيار التعليم والتعلم).</li>
        <li>نشر بحث علمي واحد على الأقل في مجلة علمية مصنفة دولياً.</li>
        <li>حضور دورتين تدريبيتين في مجال التخصص.</li>
        <li>حضور دورتين تدريبيتين في تطوير الذات.</li>
        <li>تقديم دورتين تدريبيتين في مجال التخصص للمجتمع الداخلي والخارجي.</li>
        <li>الحصول على 20 ساعة تطوعية معتمدة من الكليات (لايدخل فيها الدورات التدريبية).</li>
        <li>الحصول على تقدير لا يقل عن جيد مرتفع (75%) في تقييم الأداء السنوي.</li>
      </ul>
    </section>

    <hr />

    <section className="mb-4">
      <h5 className="mb-3 text-danger">ثانياً: متطلبات الحد الأدنى لإنجاز الموظف الإداري/الفني خلال العام الدراسي 1448هـ:</h5>
      <ul>
        <li>حضور دورتين تدريبيتين في مجال التخصص.</li>
        <li>حضور دورتين تدريبيتين في تطوير الذات.</li>
        <li>الحصول على 20 ساعة تطوعية معتمدة من الكليات (لايدخل فيها الدورات التدريبية).</li>
        <li>الحصول على تقدير لا يقل عن جيد مرتفع (75%) في تقييم الأداء السنوي.</li>
      </ul>
    </section>

    <hr />

    <section>
      <p>
        📌 عليه، نأمل من جميع الأعضاء والموظفين الالتزام بتحقيق المتطلبات أعلاه ضمن المدة المحددة،
        حرصاً على ضمان استمرارية التعاقد وتطوير الأداء الأكاديمي والإداري في  والمجتمعي في الكليات.
      </p>
    </section>
  </Modal.Body>

  <Modal.Footer>
    <Button className="primary-bg border-0" onClick={() => setAnnouncementModal(false)}>
      موافق
    </Button>
  </Modal.Footer>
   
</Modal>

)}

      <div className="row">
        <ImageCard
          className="green-gradient"
          cardIcon={asIcon}
          cornerIcon={rbIcon}
          title="كشف حساب"
          onClick={() => toggleSection("accountStatementSection")}
        />
        <ImageCard
          className="primary-gradient"
          cardIcon={depositIcon}
          title="ايداع جديد"
          onClick={() => toggleSection("newDepositSection")}
        />
        <ImageCard
          cardIcon={moneyIcon}
          cornerIcon={rbIcon}
          title="العمليات السابقة"
          onClick={() => toggleSection("allDepositSection")}
        />
        <ImageCard
          className="secondary-gradient"
          cardIcon={termsIcon}
          title="الشروط والاحكام"
          onClick={() => toggleSection("termsSection")}
        />
      </div>
      {/* Account Statement Section */}
      <div
        id="account-statement-section"
        ref={(el) => (sectionRefs.current["accountStatementSection"] = el)}
      >
        {sections.accountStatementSection && (
          <>
            <AccountStatementSection />
            <div className="d-flex justify-content-between">
              <DisableButton text="طباعة" className="mx-2" />
              {/* <ButtonComponent text="طباعة" className="green-bg button-md"/> */}
              <ButtonComponent
                text="الارشيف (النظام القديم)"
                className="green-bg button-lg mx-2"
                onClick={fetchArchiveAccountStatement}
              />

              <ButtonComponent
                text="X"
                className="green-bg button-md mx-2"
                onClick={closeSection}
              />
            </div>
            <hr />
            {archiveSection ? <ArchiveAccountStatement /> : null}
          </>
        )}
      </div>

      {/* New Deposit Section */}
      <div
        id="new-deposit-section"
        ref={(el) => (sectionRefs.current["newDepositSection"] = el)}
      >
        {sections.newDepositSection && (
          <>
            <h4 className="text-center">ايداع جديد</h4>
            {/* <TreeView/> */}
            <ButtonComponent
              text="X"
              className=" primary-gradient white-color button-md"
              onClick={closeSection}
            />
            <StandardTree />
          </>
        )}
      </div>
      {/* All Deposit Section */}
      <div
        id="all-deposit-section"
        ref={(el) => (sectionRefs.current["allDepositSection"] = el)}
        className="d-flex justify-content-center align-items-center"
      >
        {sections.allDepositSection && (
          <>
            <span ref={allDepositsscrollToTop}></span>
            <ScrollToTop scrollToElement={allDepositsscrollToTop} />
            <SelectDate
              componentTitle="تاريخ الايداع"
              onChange={handleDateChange}
            />{" "}
            <div className="d-flex flex-wrap  justify-content-evenly align-items-center mb-2  col-12">
              {/* Radio buttons for filtering */}
              <div className="">
                <RadioButton
                  label="الجميع"
                  group="filterType"
                  value={depositsDataFilter.all}
                  checked={selectedType === depositsDataFilter.all}
                  onChange={handleRadioChange}
                />
              </div>
              <div className="">
                <RadioButton
                  label="مقبولة"
                  group="filterType"
                  value={depositsDataFilter.accepted}
                  checked={selectedType === depositsDataFilter.accepted}
                  onChange={handleRadioChange}
                />
              </div>
              <div className="">
                <RadioButton
                  label="تحت المراجعة"
                  group="filterType"
                  value={depositsDataFilter.pending}
                  checked={selectedType === depositsDataFilter.pending}
                  onChange={handleRadioChange}
                />
              </div>
              <div className="">
                <RadioButton
                  label="مرفوضة"
                  group="filterType"
                  value={depositsDataFilter.rejected}
                  checked={selectedType === depositsDataFilter.rejected}
                  onChange={handleRadioChange}
                />
              </div>
            </div>
            {/* Display loading spinner or error message */}
            {isLoading ? (
              <Spinner />
            ) : error ? (
              <div className="error-message">
                <strong className="p-2 my-5 text-danger light-gray-bg border-radius-5">
                  {error}
                </strong>
              </div>
            ) : (
              <>
                {filteredData.length === 0 ? (
                  ""
                ) : (
                  <div className="my-4 d-flex flex-column justify-content-baseline">
                    <h3>
                      <strong>عدد الايداعات</strong>
                    </h3>
                    <strong className="blue-bg white-color mx-2  text-center button-md">
                      {(() => {
                        const typeMap = {
                          rejected: " المرفوضة ",
                          pending: " تحت المراجعة ",
                          accepted: " المقبولة ",
                        };

                        return typeMap[selectedType] || " الجميع ";
                      })()}
                      {filteredData.length}
                    </strong>
                  </div>
                )}
                {/* Pass the date change handler */}
                <button
                  onClick={toggleMonthFilter}
                  className="button-outline-primary blue-color"
                >
                  {isMonthFilterActive
                    ? "إلغاء تصفية الشهر"
                    : "تصفية حسب الشهر"}
                </button>
                {isMonthFilterActive && (
                  <div className="month-filter-container p-3 mb-4 mt-4 border rounded bg-light">
                    <div className="row align-items-center">
                      {/* From Month Selector */}
                      <div className="col-md-4 col-sm-6 mb-2">
                        {/* <label className="form-label">من شهر:</label> */}
                        <select
                          className="form-select"
                          value={fromMonth}
                          onChange={handleFromMonthChange}
                        >
                          <option value="">من </option>
                          {Array.from({ length: 12 }, (_, i) => (
                            <option
                              key={i + 1}
                              value={String(i + 1).padStart(2, "0")}
                            >
                              {i + 1}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* To Month Selector */}
                      <div className="col-md-4 col-sm-6 mb-2">
                        {/* <label className="form-label">إلى شهر:</label> */}
                        <select
                          className="form-select"
                          value={toMonth}
                          onChange={handleToMonthChange}
                        >
                          <option value="">الى</option>
                          {Array.from({ length: 12 }, (_, i) => (
                            <option
                              key={i + 1}
                              value={String(i + 1).padStart(2, "0")}
                            >
                              {i + 1}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Update Button */}
                      <div className="col-md-4 d-flex justify-content-start justify-content-md-end mt-2 mt-md-0">
                        <button
                          onClick={handleUpdateClick}
                          className="button-md blue-bg white-color"
                        >
                          تحديث
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {monthFilterError ? (
                  <div className="error-message my-3">
                    <strong className="p-2 my-5 text-danger light-gray-bg border-radius-5">
                      {monthFilterError}
                    </strong>
                  </div>
                ) : null}
                <div className="d-flex flex-row flex-wrap justify-content-center">
                  {filteredData.length === 0 ? (
                    <div className="error-message my-3">
                      <strong className="p-2 my-5 text-danger light-gray-bg border-radius-5">
                        لايوجد بيانات .
                      </strong>
                    </div>
                  ) : (
                    filteredData.map((deposit, index) => (
                      <DepositCard
                        key={index}
                        deposit={deposit}
                        index={index}
                      />
                    ))
                  )}
                </div>
              </>
            )}
            <ButtonComponent
              text="X"
              className="blue-bg white-color button-md my-5"
              onClick={closeSection}
            />
          </>
        )}
      </div>

      {/* Account Statement Section */}
      <div
        id="terms-section"
        ref={(el) => (sectionRefs.current["termsSection"] = el)}
      >
        {sections.termsSection && (
          <>
            <h4 className="text-center">الشروط والاحكام</h4>
            <TermsSection />
            <div className="d-flex justify-content-between">
              <ButtonComponent
                text="X"
                className=" secondary-gradient white-color button-md mx-2"
                onClick={closeSection}
              />
            </div>
          </>
        )}
      </div>


    </Layout>
  );
}
export default HomePage;
